import { Box } from '@material-ui/core';
import { LenderName } from '@nemuru-eng/js-api-client';

import { ReportsListRowProps } from '@/components/modules/Reports/ReportsList/types/ReportsListRowProps';
import { LenderIcon } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { StyledTooltip } from '@/components/shared/components/StyledTooltip';
import { Font } from '@/components/shared/components/Font';

import { Text } from '../../../../../../shared/components/Text';

const MAX_LENDERS = 4;
export const lenderFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.4,
    field: 'lender',
    align: 'right',
    sortable: false,
    headerName: (
      <Box minWidth={'120px'} textAlign={'end'}>
        <Text tId={'LENDERS'} />
      </Box>
    ),
    renderCell: (rowData: ReportsListRowProps) => {
      const lenders = rowData.row.payouts
        .reduce((acc, payout) => {
          if (!acc.includes(payout.lender)) {
            acc.push(payout.lender);
          }
          return acc;
        }, [] as LenderName[])
        .sort((a, b) => a.charCodeAt(0) - b.charCodeAt(0));

      const lendersRemoved = lenders.length - MAX_LENDERS;
      let maxVisibleLendersArray = lenders;

      if (lenders.length > MAX_LENDERS) {
        maxVisibleLendersArray = lenders.slice(0, MAX_LENDERS);
      }

      return (
        <StyledTooltip title={lenders.join(', ')}>
          <Box display="flex" minWidth={'120px'} alignItems="center" justifyContent="flex-end" gridGap="5px">
            {maxVisibleLendersArray.map((lender) => LenderIcon({ lenderName: lender }))}
            {lendersRemoved > 0 && (
              <Font variant="body1" color="textSecondary">
                {` +${lendersRemoved}`}
              </Font>
            )}
          </Box>
        </StyledTooltip>
      );
    },
  };
};
